
import PropTypes from 'prop-types';
import React from 'react';
import Base from './Base';
import config from './config';

/** Component for displaying flash and error messages */

const Message = ({ theme = 'default', inverted = true, rounded = true, ...props }) => {
  const { bold, scale } = config;

  return (
    <Base
      {...props}
      theme={theme}
      inverted={inverted}
      rounded={rounded}
      className="Message"
      baseStyle={{
        fontWeight: bold,
        display: 'flex',
        alignItems: 'center',
        padding: scale[2],
        marginBottom: scale[2],
      }}
    />
  );
};

Message.propTypes = {
  /** Sets color from config */
  theme: PropTypes.oneOf([
    'primary',
    'secondary',
    'default',
    'info',
    'success',
    'warning',
    'error',
  ]),
};

export default Message;

